import React, { useState } from 'react';
import { Box } from '@chakra-ui/react';
import DoctorCardsView from './DoctorCardsView';
import PatientsTableView from './PatientsTableView';

function PatientsHistory() {
  const [view, setView] = useState('doctors'); // doctors | patients
  const [selectedDoctor, setSelectedDoctor] = useState(null);

  return (
    <Box p={4} mt={10}>
      {view === 'doctors' && (
        <DoctorCardsView
          onDoctorSelect={(doctor) => {
            setSelectedDoctor(doctor);
            setView('patients');
          }}
        />
      )}

      {view === 'patients' && (
        <PatientsTableView
          doctor={selectedDoctor}
          onBack={() => {
            setSelectedDoctor(null);
            setView('doctors');
          }}
        />
      )}
    </Box>
  );
}

export default PatientsHistory;
